<div *transloco="let t">

    <div mat-flat-button [matMenuTriggerFor]="userActions" class="flex items-center h-9 rounded-lg border border-white/10 cursor-pointer hover:border-white/20 hover:bg-white/[0.06] transition-all duration-150">
        <!-- Avatar -->
        <button class="flex items-center justify-center w-9 h-9 rounded-lg">
            <mat-icon
                class="icon-size-5 text-white/60"
                *ngIf="!showAvatar || !user.avatar"
                [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </button>
        <span>
            <span class="hidden md:block text-[13px] font-medium text-white/80 pr-3">
                {{user.firstName}} {{user.lastName}}
            </span>
        </span>
    </div>

    <mat-menu
        [xPosition]="'before'"
        class="mt-1 min-w-64"
        #userActions="matMenu">
        <button mat-menu-item class="!h-auto !py-3">
            <span class="flex flex-col gap-0.5">
                <span class="text-sm font-semibold text-gray-800 dark:text-gray-100">
                    {{user.firstName}} {{user.lastName}}
                </span>
                <span class="text-xs text-gray-400">{{user.email}}</span>
                <span *ngIf="displayProfile"
                      class="mt-1 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-primary-50 text-primary-700 dark:bg-primary-900/60 dark:text-primary-300 w-fit">
                    {{ t('enums.entity_types.' + displayProfile.name) }}
                </span>
            </span>
        </button>
        <mat-divider class="my-1"></mat-divider>
        <button mat-menu-item (click)="navigateToProfile()">
            <mat-icon class="text-gray-400" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span class="text-sm">
                {{t("user.profile.title")}}
            </span>
        </button>
        <button *ngIf="canSwitchProfile" mat-menu-item (click)="openProfileSwitch()">
            <mat-icon class="text-gray-400" [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
            <span class="text-sm">{{t("user.switch_profile.title")}}</span>
        </button>

        <mat-divider class="my-1"></mat-divider>
        <button
            mat-menu-item
            (click)="signOut()">
            <mat-icon class="text-gray-400" [svgIcon]="'heroicons_outline:logout'"></mat-icon>
            <span class="text-sm">
                {{t("user.logout.title")}}
            </span>
        </button>
    </mat-menu>
</div>
